export default __webpack_public_path__ + "static/media/indonesia.e06c2d74.png";